export default __webpack_public_path__ + "static/WPS-P2P_08-5ed18a8486ece4f07b9d411483d033fe.webp";